export default "__VITE_ASSET__IyVz3ulZ__"